import {AfterViewInit, Component, ElementRef, input, signal, ViewChild} from '@angular/core';
import {NgClass, NgStyle} from '@angular/common';
import {TranslocoPipe} from '@ngneat/transloco';

@Component({
    selector: 'lib-show-more-less',
    imports: [
        TranslocoPipe,
        NgStyle,
        NgClass
    ],
    templateUrl: './show-more-less.component.html',
    styleUrl: './show-more-less.component.scss'
})
export class ShowMoreLessComponent implements AfterViewInit {
  @ViewChild('textContainer') textContainer!: ElementRef;

  minimizedRows = input<number>(1);
  text = input.required<string>();
  minimized = signal(true);
  showLabel = signal(false);

  constructor() { }

  ngAfterViewInit() {
    this.checkOverflow();
  }

  checkOverflow() {
    setTimeout(() => {
      const element = this.textContainer.nativeElement;
      this.showLabel.set(element.scrollHeight > element.clientHeight);
    });
  }
}
